var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSettings48(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_64",
    "data-name": "Grupo 64",
    transform: "translate(-463 -837)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(463 837)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_15",
    "data-name": "Caminho 15",
    d: "M6,20.863a15,15,0,0,0,30,0m-30,0a15,15,0,1,1,30,0m-30,0H3m33,0h3m-3,0H21M4.086,27.017l2.82-1.026M35.1,15.731l2.82-1.026M7.212,32.433l2.3-1.928m22.98-19.284,2.3-1.928M12,36.453l1.5-2.6m15-25.98,1.5-2.6M17.876,38.589l.52-2.954m5.21-29.544.52-2.954m0,35.452-.52-2.954M18.4,6.091l-.52-2.954M30,36.451l-1.5-2.6M12,5.273l9,15.59m13.788,11.57L32.49,30.5M9.512,11.219l-2.3-1.928m30.7,17.728L35.1,25.993M6.908,15.733l-2.82-1.028M21,20.863l-7.5,12.99",
    transform: "translate(466.5 840.363)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings48);
export default __webpack_public_path__ + "static/media/icon_settings-48.5671b77437182a4fa0f6b6a08ad63630.svg";
export { ForwardRef as ReactComponent };